import { UserVerificationStatus} from 'models';
export class Event {
    id: number;
    title: string;
    start: string;
    end: string;
    allDay: boolean = true;
    guestStatus: UserVerificationStatus;
}
